import React, {Fragment} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Table} from "reactstrap";

const SmartReportPreview = ({isOpen, toggle, report}) => {
    if (!report) return null;

    const preview = report.preview_data || {};
    // Support both new format {headings, rows} and old format (flat array)
    const headings = preview.headings || (Array.isArray(preview) && preview.length > 0 ? Object.keys(preview[0]) : []);
    const rows = preview.rows || (Array.isArray(preview) ? preview : []);

    const handleDownload = () => {
        if (report.file_url) {
            const link = document.createElement("a");
            link.href = report.file_url;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" scrollable>
            <ModalHeader toggle={toggle}>
                {report.report_name || 'Report Preview'}
                {report.row_count != null && <small className="text-muted ml-2"> ({report.row_count} rows)</small>}
            </ModalHeader>
            <ModalBody>
                {report.status === 'failed' && (
                    <div className="alert alert-danger">
                        {report.error_message || 'Report generation failed.'}
                    </div>
                )}
                {report.status === 'completed' && report.row_count === 0 && (
                    <div className="alert alert-warning">
                        No data found for the selected filters. Try a wider date range or different filters.
                    </div>
                )}
                {report.status === 'completed' && rows.length > 0 && (
                    <Fragment>
                        <p className="text-muted mb-2">Showing first {rows.length} of {report.row_count} rows</p>
                        <div className="table-responsive" style={{maxHeight: '500px', overflow: 'auto'}}>
                            <Table bordered striped size="sm">
                                <thead style={{position: 'sticky', top: 0, backgroundColor: '#f8f9fa'}}>
                                    <tr>
                                        {headings.map((heading, idx) => (
                                            <th key={idx} style={{whiteSpace: 'nowrap', fontSize: '12px'}}>{heading}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, rowIdx) => (
                                        <tr key={rowIdx}>
                                            {headings.map((heading, colIdx) => (
                                                <td key={colIdx} style={{whiteSpace: 'nowrap', fontSize: '12px'}}>
                                                    {row[heading] !== null && row[heading] !== undefined ? String(row[heading]) : ''}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Fragment>
                )}
            </ModalBody>
            <ModalFooter>
                {report.status === 'completed' && report.file_url && (
                    <Button color="primary" onClick={handleDownload}>
                        <i className="fa fa-download mr-1"></i> Download Excel
                    </Button>
                )}
                <Button color="secondary" onClick={toggle}>Close</Button>
            </ModalFooter>
        </Modal>
    );
};

export default SmartReportPreview;
